var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCourthouseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.316,
    height: 22.316,
    viewBox: "0 0 22.316 22.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.294,1.395H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0h18.6a.7.7,0,0,1,.7.7A.7.7,0,0,1,19.294,1.395Z",
    transform: "translate(1.162 19.759)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.022,4.641a6.948,6.948,0,0,1-2.585-.5A.7.7,0,0,1,0,3.488V.7A.686.686,0,0,1,.307.122.707.707,0,0,1,.958.048a5.558,5.558,0,0,0,4.128,0,.707.707,0,0,1,.651.074A.686.686,0,0,1,6.044.7V3.488a.71.71,0,0,1-.437.651A6.948,6.948,0,0,1,3.022,4.641ZM1.395,3A5.546,5.546,0,0,0,4.649,3V1.656a6.878,6.878,0,0,1-3.254,0Z",
    transform: "translate(10.461 1.152)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.7,4.184a.7.7,0,0,1-.7-.7V.7A.7.7,0,0,1,.7,0a.7.7,0,0,1,.7.7V3.487A.7.7,0,0,1,.7,4.184Z",
    transform: "translate(10.461 3.952)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.575,14.412H.7a.7.7,0,0,1-.7-.7V3.487A3.144,3.144,0,0,1,3.487,0h9.3a3.144,3.144,0,0,1,3.487,3.487V13.715A.7.7,0,0,1,15.575,14.412ZM1.395,13.018H14.877V3.487c0-1.469-.623-2.092-2.092-2.092h-9.3c-1.469,0-2.092.623-2.092,2.092Z",
    transform: "translate(3.022 6.741)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,1.395H.7A.7.7,0,0,1,0,.7.7.7,0,0,1,.7,0H14.5a.7.7,0,0,1,.7.7A.7.7,0,0,1,14.5,1.395Z",
    transform: "translate(3.561 10.461)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.395V9.3H0Z",
    transform: "translate(6.732 11.158)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.395V9.3H0Z",
    transform: "translate(10.451 11.158)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.395V9.3H0Z",
    transform: "translate(14.171 11.158)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H22.316V22.316H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCourthouseWhite);
export default __webpack_public_path__ + "static/media/vuesax-outline-courthouse - white.37c75971cca171c9295978d02f5807b1.svg";
export { ForwardRef as ReactComponent };